import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import CarDocument from "../components/CarDocument";
import TopNav from "../../../components/TopNav";
import { getCart, getCartNoFee } from "../../../actions/cart.action";
import { makeDocumentPayment } from "../../../actions/payment.action";
import { getOutstandingAlumniFee } from "../../../actions/fee.action";
import { AiOutlineShoppingCart } from "react-icons/ai";
import ButtomButton from "../../../components/DocButtomButton";
import { Loading } from "../../../utils/helpers/constants";
import { removeCartItem } from "../../../actions/cart.action";
import RoundLoader from "../../../components/loader/RoundLoader";

export default function CartPage() {
  const history = useHistory();
  const dispatch = useDispatch();
  const [payoutStanding, setPayoutStanding] = useState(false);

  useEffect(() => {
    const addAlumniFee = true;
    dispatch(getCart(addAlumniFee));
    dispatch(getOutstandingAlumniFee());
  }, []);

  const { profile } = useSelector(({ profileReducer }) => ({
    profile: profileReducer,
  }));

  const {
    fee: { outstandingAlumniFee },
  } = useSelector(({ feeReducer }) => ({
    fee: feeReducer,
  }));

  const {
    cart: { cart, cartItems, cartLoading, deleteCartLoading, noFeeCartLoading },
  } = useSelector(({ cartReducer }) => ({
    cart: cartReducer,
  }));

  const {
    payment: { partnerLink, paymentLoading },
  } = useSelector(({ paymentReducer }) => ({
    payment: paymentReducer,
  }));

  const pay = () => {
    const baseUrl = window.location.origin;
    const payload = {
      paymentGateway: "FLUTTERWAVE",
      redirectUrl: baseUrl + "/payment/verify-payment",
      paymentChannel: "BANK_ACCOUNT",
      transactionType: "BANK_TRANSFER",
      payOutStanding: payoutStanding,
    };
    const navigateLink = () => history.push(partnerLink);
    dispatch(makeDocumentPayment(payload, navigateLink));
  };

  const removeFromBag = (cart) => {
    const reload = () => history.go(0);
    dispatch(removeCartItem(cart.id, reload));
  };

  const loadState =
    profile.userProfileLoading === Loading.FETCHING ||
    cartLoading === Loading.FETCHING ||
    deleteCartLoading === Loading.FETCHING;
  const buttonLoadState = paymentLoading === Loading.FETCHING;

  const handlePayoutStanding = (value) => {
    setPayoutStanding(value);
    if (value) {
      dispatch(getCart(true));
      // dispatch(getOutstandingAlumniFee());
    } else {
      //get cart minus alumni
      dispatch(getCartNoFee(value));
    }
  };

  return (
    <>
      <div className="overflow-hidden">
        <div className=" doc_processing_color h-44 px-2 pt-3">
          <TopNav link={"/dashboard/user/document-processing"} />
          <div className="transcript_header">Document Processing Payment</div>
          <div className="text-md md:text-lg w-2/3">
            Process your Certificate, Transcript, English Waiver etc
          </div>
        </div>
      </div>

      {loadState ? (
        <RoundLoader />
      ) : (
        <div>
          {cartItems.length === 0 ? (
            <>
              <div className="md:flex md:items-center md:justify-center text-center md:p-4 min-h-full">
                <div className="relative bg-white rounded-lg text-left overflow-hidden md:shadow-xl md:pb-5 transform transition-all sm:my-8 sm:max-w-lg sm:w-full">
                  <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                    <div className="flex flex-col items-center justify-center p-2">
                      <AiOutlineShoppingCart
                        size={40}
                        onClick={() =>
                          history.push(
                            "/dashboard/user/document-processing/cart-orders"
                          )
                        }
                      />
                      <div className="text-md text-center font-bold">
                        Your bag is empty!
                      </div>
                      <div>
                        Return to document processing and select document!
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              {" "}
              <div className="font-bold md:text-lg md:w-2/3 px-2 md:px-20 md:py-10 py-2">
                Please note that each request takes 5 working days after payment
                and confirmation of all documentation provided.
              </div>
              <div className="md:flex md:items-center md:justify-center text-center md:p-4 min-h-full">
                <div className="relative bg-white rounded-lg text-left overflow-hidden md:shadow-xl md:pb-5 transform transition-all sm:my-8 sm:max-w-lg sm:w-full">
                  <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                    <div className="flex justify-end cursor-pointer"></div>
                    <div>
                      {cartItems.map((item, index) => {
                        return (
                          <CarDocument
                            key={index}
                            cart={item}
                            removeFromBag={(cart) => removeFromBag(cart)}
                          />
                        );
                      })}
                    </div>
                    <hr className="mt-20" />
                    <div className="py-2">
                      <div className="flex justify-between">
                        <div className="font-bold">Sub Total</div>
                        <div>
                          <div className="compass_color font-bold">
                            N{cart?.totalDocumentFee}
                          </div>
                        </div>
                      </div>
                      <div className="flex justify-between">
                        <div className="font-bold">Delivery Fee</div>
                        <div>
                          <div className="compass_color font-bold">
                            N{cart?.totalDeliveryFee}
                          </div>
                        </div>
                      </div>
                      <div className="flex justify-between">
                        <div className="font-bold">Alumni Processing Fee</div>
                        <div>
                          <div className="compass_color font-bold">
                            N{cart?.alumniFee}
                          </div>
                        </div>
                      </div>
                      <div className="flex justify-between">
                        <div>
                          <input
                            defaultChecked
                            id="link-checkbox"
                            type="checkbox"
                            value={payoutStanding}
                            onChange={(e) =>
                              handlePayoutStanding(e.target.checked)
                            }
                            className="checkbox-square mr-1 leading-tight focus:ring-green-500 w-full"
                          />
                          <label htmlFor="link-checkbox" className="font-bold">
                            Outstanding Alumni Due(?)
                          </label>
                        </div>
                        <div>
                          <div className="compass_color font-bold">
                            {noFeeCartLoading
                              ? "Loading..."
                              : `N${cart.outstandingAlumniFee}`}
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div className="flex justify-between mt-2">
                      <div className="font-bold">Total</div>
                      <div>
                        <div className="compass_color font-bold text-right">
                          N{cart.totalCost}
                        </div>
                        <div className="text-xs">Inclusive of V.A.T</div>
                      </div>
                    </div>
                  </div>
                  <ButtomButton
                    name={"Proceed to pay"}
                    func={pay}
                    loading={buttonLoadState}
                  />
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
}
